import { defineComponent as _defineComponent } from 'vue'
import { Form } from "vee-validate";

import { computed, inject, ref } from "vue";
import { useUserStore } from "@/stores/userStore";
import { useServiceStore } from "@/stores/serviceStore";
import {
  ChangePasswordExpiredSourceType,
  PROVIDE_KEY_SHOW_ERROR_MODAL,
  PROVIDE_KEY_SHOW_TOAST_MESSAGE,
  RouterName,
  ShowErrorModal,
  ShowToastMessage,
} from "@/types";
import router from "@/router";
import BaseButton from "@/components/shared/button/base/BaseButton.vue";
import PasswordInput from "@/components/shared/inputs/PasswordInput.vue";
import TextInput from "@/components/shared/inputs/TextInput.vue";
import { useRoute } from "vue-router";


const __default__ = {
  name: "ChangePasswordForm",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  isPasswordExpired: {
    type: Boolean,
    default: false,
  },
  source: {
    type: String,
    default: "",
  },
},
  setup(__props, { expose: __expose }) {
  __expose();

const showErrorModal = inject(PROVIDE_KEY_SHOW_ERROR_MODAL) as ShowErrorModal;
const showToastMessage = inject(
  PROVIDE_KEY_SHOW_TOAST_MESSAGE
) as ShowToastMessage;

const props = __props;

const route = useRoute();

const serviceStore = useServiceStore();
const userStore = useUserStore();
const userId = ref("");
userId.value = userStore.loginId ?? "";
const shouldShowUserIdInput = !userStore.loginId.length;
const canExtendPasswordExpiration = computed(
  () =>
    (serviceStore.serviceInfo?.passwordNextChangeLimit ?? 0) >
    (userStore.userInfo?.passwordReuseCount ?? 0)
);

const currentPassword = ref("");
const newPassword = ref("");
const confirmedNewPassword = ref("");

const passwordField = computed(() =>
  serviceStore.signupInfos?.[0]?.fields?.find(
    (field) => field.key === "JOIN.PASSWORD"
  )
);

const passwordPlaceholder = computed(() =>
  passwordField.value?.placeholder?.split("(")?.[1]?.replace(")", "")
);

const passwordErrorMessage = computed(() =>
  passwordPlaceholder.value
    ? passwordPlaceholder.value + "으로 입력해주세요."
    : "비밀번호 양식에 맞게 입력해주세요."
);

const schema = computed(() => {
  return {
    id: shouldShowUserIdInput ? { required: "아이디를" } : {},
    currentPassword: { required: "현재 비밀번호를" },
    newPassword: {
      required: "새 비밀번호를",
      password: [
        passwordField.value?.passwordRegex,
        passwordErrorMessage.value,
      ],
      newPassword: "@currentPassword",
    },
    confirmedNewPassword: {
      required: "새 비밀번호를 다시",
      passwordConfirm: "@newPassword",
    },
  };
});

const errorMessage = ref("");
const handleClickChangePasswordBtn = async (isCompleteForm: boolean) => {
  props.isPasswordExpired
    ? updatePasswordExpired(isCompleteForm)
    : changePassword(isCompleteForm);
};

/** 임시 비밀번호 변경 */
const changePassword = async (isCompleteForm: boolean) => {
  if (!isCompleteForm) return;

  const updatePasswordResult = await userStore.changePassword({
    currPassword: currentPassword.value,
    nextPassword: newPassword.value,
    nextPasswordCert: confirmedNewPassword.value,
  });

  if (updatePasswordResult.isSuccess) {
    showToastMessage("비밀번호가 변경되었습니다", 3000, 350);

    router.replace({ name: RouterName.MainLogin });
    return;
  }

  if (updatePasswordResult.resultCode === 401000010) {
    errorMessage.value = "비밀번호를 정확하게 입력해주세요.";
    return;
  }

  showErrorModal(
    "비밀번호 변경 오류",
    updatePasswordResult.errorMessage,
    updatePasswordResult.resultCode,
    updatePasswordResult.errorTime
  );
};

/** 만료된 비밀번호 변경 */
const updatePasswordExpired = async (isCompletForm: boolean) => {
  if (!isCompletForm) return;

  const updatePasswordResult = await userStore.updatePassword(
    userId.value,
    currentPassword.value,
    newPassword.value
  );

  if (updatePasswordResult.isSuccess) {
    showToastMessage("비밀번호가 변경되었습니다", 3000, 350);

    router.replace({ name: RouterName.MainLogin });
    return;
  }
  if (updatePasswordResult.resultCode === 401000010) {
    errorMessage.value = "비밀번호를 정확하게 입력해주세요.";
    return;
  }
  showErrorModal(
    "비밀번호 변경 오류",
    updatePasswordResult.errorMessage,
    updatePasswordResult.resultCode,
    updatePasswordResult.errorTime
  );
};

const extendPasswordExpiration = async () => {
  const extendResult = await userStore.extendPasswordExpiration();

  if (!extendResult.isSuccess) {
    const { errorMessage, errorTime, resultCode } = extendResult;
    showErrorModal(
      "비밀번호 만료기한 연장 오류",
      errorMessage,
      resultCode,
      errorTime
    );
    return;
  }

  if (props.source === ChangePasswordExpiredSourceType.ACTIVE) {
    route.meta.willGoBack = true;
    router.back();
    return;
  }
  router.replace({ name: RouterName.MainLogin });
};

const resetErrorMessage = () => {
  errorMessage.value = "";
};

const __returned__ = { showErrorModal, showToastMessage, props, route, serviceStore, userStore, userId, shouldShowUserIdInput, canExtendPasswordExpiration, currentPassword, newPassword, confirmedNewPassword, passwordField, passwordPlaceholder, passwordErrorMessage, schema, errorMessage, handleClickChangePasswordBtn, changePassword, updatePasswordExpired, extendPasswordExpiration, resetErrorMessage, get Form() { return Form }, BaseButton, PasswordInput, TextInput }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})